<template>
  <div>
    <h1 slot="title" class="page-title">Edit Occupant</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <div class="form-horizontal">
              <selectlist
                :options="types"
                v-model="form.type_id"
                label="Occupant Type"
                name="type"
                placeholder="Please Select"
              ></selectlist>

              <inputbox
                v-model="form.first_name"
                name="first_name"
                label="First Name"
              ></inputbox>

              <inputbox
                v-model="form.last_name"
                name="last_name"
                label="Last Name"
              ></inputbox>

              <date-of-birth
                :required="true"
                v-model="form.date_of_birth"
                :unlimited="true"
              ></date-of-birth>

              <inputbox
                v-model="form.occupation"
                name="occupation"
                label="Occupation"
              ></inputbox>

              <inputbox
                v-model="form.medical_conditions"
                name="medical_conditions"
                label="Medical Conditions"
              ></inputbox>

              <inputbox
                v-model="form.relation_to_client"
                name="relation_to_client"
                label="Relation to Client"
              ></inputbox>

              <inputbox
                v-model="form.national_insurance"
                name="national_insurance_number"
                label="National Insurance Number"
              ></inputbox>

              <selectlist
                :options="positions"
                v-model="form.position_id"
                label="Seat/Position"
                name="position"
                placeholder="Please Select"
              ></selectlist>

              <toggleswitch
                :labels="true"
                name="requires_glasses"
                label="Requires Glasses?"
                v-model="form.requires_glasses"
              ></toggleswitch>

              <toggleswitch
                :labels="true"
                name="wearing_seatbelt"
                label="Wearing Seatbelt?"
                v-model="form.wearing_seatbelt"
              ></toggleswitch>

              <fieldset>
                <legend>
                  Contact Details
                  <small class="text-muted"
                    >- Enter the occupants contact details here
                  </small>
                </legend>

                <inputbox
                  v-model="form.telephone"
                  name="telephone"
                  label="Telephone"
                ></inputbox>

                <inputbox
                  v-model="form.email_address"
                  name="email"
                  label="Email Address"
                  type="email"
                ></inputbox>
              </fieldset>
              <fieldset>
                <legend>
                  Address Details
                  <small class="text-muted"
                    >- Enter the occupants address details here
                  </small>
                </legend>
                <address-lookup
                  :address="address"
                  v-on:address="setAddress"
                ></address-lookup>
              </fieldset>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-danger btn-raised float-left"
              name="delete"
              v-on:click.prevent="deleteOccupant"
            >
              <i class="icon icon-delete"></i> Delete
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="cancel"
              v-on:click.prevent="cancel"
            >
              <i class="icon icon-cancel"></i> Back
            </button>
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="updateOccupant"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    occupant: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      types: [],
      positions: [],
      client: null,
      occupantData: null,
      form: {},
      indicator: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      window.Ajax.get(
        '/incidents/' + this.incident + '/occupants/' + this.occupant
      )
        .then(response => {
          this.form = new window.Form({
            type_id: response.data.type_id,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            date_of_birth: window.DateManager.format(
              response.data.date_of_birth
            ),
            occupation: response.data.occupation,
            medical_conditions: response.data.medical_conditions,
            relation_to_client: response.data.relation_to_client,
            national_insurance: response.data.national_insurance,
            position_id: response.data.position_id,
            requires_glasses: response.data.requires_glasses,
            wearing_seatbelt: response.data.wearing_seatbelt,
            telephone: response.data.telephone,
            email_address: response.data.email_address,
            address_line_one: response.data.address_line_one,
            address_line_two: response.data.address_line_two,
            city: response.data.city,
            postcode: response.data.postcode
          });
        })
        .catch(error => {});

      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/occupant-types')
        .then(response => {
          this.types = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/seat-positions')
        .then(response => {
          this.positions = response.data;
        })
        .catch(error => {});
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    updateOccupant() {
      this.form
        .put('/incidents/' + this.incident + '/occupants/' + this.occupant)
        .then(response => {
          this.$emit('updated', response);
          this.$router.push(
            `/first-notice-of-loss-plus/${this.incident}#parties`
          );
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the witness'
          );
        });
    },

    deleteOccupant() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/incidents/' + this.incident + '/occupants/' + this.occupant
            )
              .then(response => {
                this.$emit('deleted', this.occupant);
                this.indicator = false;
                this.$router.push(
                  `/first-notice-of-loss-plus/${this.incident}#parties`
                );
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the occupant.'
                );
              });
          }
        })
        .catch(error => {});
    },

    cancel() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
          this.$router.push(
            `/first-notice-of-loss-plus/${this.incident}#parties`
          );
        })
        .catch(error => {});
    }
  }
};
</script>
